import { createAsyncThunk } from "@reduxjs/toolkit";

import { getUser, LoyaltyApi } from "@jti/rest-api";

const fetchOrderPointsDeclaration = (isFreeTrial: boolean) =>
  createAsyncThunk(
    isFreeTrial ? "freeTrialOrder/fetchOrderPoints" : "order/fetchOrderPoints",
    async (orderId: string) => {
      const loyaltyApi = LoyaltyApi.init();
      const { ciam_token, uuid } = getUser();

      return loyaltyApi.getEarnedPoints(orderId, ciam_token, uuid);
    }
  );

export const fetchOrderPoints = fetchOrderPointsDeclaration(false);
export const fetchFreeTrialOrderPoints = fetchOrderPointsDeclaration(true);
